import * as React from "react";
import { PbrInput } from "src/components/common/PbrInput/PbrInput";
import { PbrInputCpf } from "src/components/common/PbrInputCpf/PbrInputCpf";
import { FormComponentProps } from "antd/lib/form";
import { Row, Col } from "antd";
import { CpfCnpjMask } from "src/util/Masks/CpfCnpjMask";
import { Dispatch, SetStateAction } from "react";
import { CivilStatus } from "../CivilStatus/CivilStatus";
import { ITrade } from "src/services/interfaces/trade/ITrade";
import { ITradeOwner } from "src/services/interfaces/trade/tradeOwner/ITradeOwner";
import { EditRG } from '../EditRG/EditRG';

interface IEditTradeOwner extends FormComponentProps {
  trade: ITrade;
  setTrade: Dispatch<SetStateAction<ITrade>>;
  onChange: (value: Partial<ITradeOwner>) => void;
  setLoading: Dispatch<SetStateAction<boolean>>;
  isProfessionRequired: boolean;
  isMotherNameRequired: boolean;
  isFatherNameRequired: boolean;
  isCivilStatusRequired: boolean;
  isRGDateRequired: boolean
  isIssuingAuthorityRequired: boolean;
}

export const EditTradeOwnerPessoaFisica: React.FC<IEditTradeOwner> = ({
  trade,
  setTrade,
  onChange,
  setLoading,
  isMotherNameRequired,
  isCivilStatusRequired,
  isProfessionRequired,
  isFatherNameRequired,
  isRGDateRequired,
  isIssuingAuthorityRequired,
  form
}) => (
  <>
    <Row gutter={16}>
      <Col xs={24} sm={24} md={12} lg={12}>
        <PbrInput
          formWrapper={form}
          name="fullName"
          value={trade.tradeOwner?.fullName}
          style={{ color: "black" }}
          placeholder={"Nome completo"}
          formItemProps={{ label: "Nome completo" }}
          rules={[{ required: true, message: "O nome é obrigatório" }]}
          onChange={e => onChange({ fullName: e.target.value })} />
      </Col>

      <Col xs={24} sm={24} md={12} lg={12}>
        <PbrInputCpf
          name="cpfCnpj"
          value={CpfCnpjMask(trade.tradeOwner?.cpfCnpj)}
          style={{ color: "black" }}
          placeholder={"CPF"}
          formItemProps={{ label: "CPF" }}
          rules={[{ required: true, message: "O CPF é obrigatório" }]}
          allowCnpj={true}
          onChange={e => onChange({ cpfCnpj: e.target.value })}
          formWrapper={form}
        />
      </Col>
    </Row>

    <EditRG
      trade={trade}
      onChange={onChange}
      form={form}
      isOwnerRG={true}
      isRGrequired
      isRGDateRequired={isRGDateRequired}
      isIssuingAuthorityRequired={isIssuingAuthorityRequired}
    />

    <Row gutter={16}>
      <Col xs={24} sm={24} md={12} lg={12}>
        <PbrInput
          name="nationality"
          value={trade.tradeOwner?.nationality}
          style={{ color: "black" }}
          formItemProps={{ label: "Nacionalidade" }}
          formWrapper={form}
          rules={[{ required: true, message: "Nacionalidade é obrigatório" }]}
          onChange={e => onChange({ nationality: e.target.value })}
        />
      </Col>
      <Col xs={24} sm={24} md={12} lg={12}>
        <PbrInput
          name="profession"
          value={trade.tradeOwner?.profession}
          style={{ color: "black" }}
          formItemProps={{ label: "Profissão" }}
          formWrapper={form}
          rules={[{ required: isProfessionRequired, message: "Profissão é obrigatório" }]}
          onChange={e => onChange({ profession: e.target.value })}
        />
      </Col>

      <Col xs={24} sm={24} md={12} lg={12}>
        <PbrInput
          name="mothersName"
          value={trade.tradeOwner?.mothersName}
          style={{ color: "black" }}
          placeholder="Nome completo da mãe"
          formItemProps={{ label: "Nome completo da mãe" }}
          formWrapper={form}
          rules={[{ required: isMotherNameRequired, message: "O nome da mãe é obrigatório" }]}
          onChange={e => onChange({ mothersName: e.target.value })} />
      </Col>

      <Col xs={24} sm={24} md={12} lg={12}>
        <PbrInput
          name="fathersName"
          value={trade.tradeOwner?.fathersName}
          style={{ color: "black" }}
          placeholder="Nome completo do pai"
          formItemProps={{ label: "Nome completo do pai" }}
          formWrapper={form}
          rules={[{ required: isFatherNameRequired, message: "O nome do pai é obrigatório" }]}
          onChange={e => onChange({ fathersName: e.target.value })} />
      </Col>
    </Row>
    <CivilStatus trade={trade} setTrade={setTrade} onChange={onChange} setLoading={setLoading} form={form} isCivilStatusRequired={isCivilStatusRequired} />
  </>
)



// WEBPACK FOOTER //
// ./src/components/common/TradeEdit/EditTradeOwner/EditTradeOwnerPessoaFisica.tsx